module.exports = __webpack_public_path__ + "static/media/mympy-logo-mini.a726d6b2.PNG";